import React from "react";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid } from "recharts";
import { eurf, tipStyle } from "./shared";

export default function SubscriptionsView({ fin }) {
  if (!fin) return <p className="text-zinc-500">Chargement…</p>;
  const c = fin.counts;
  const card = (label, val, tint, tid) => (
    <div data-testid={tid} className="rounded-2xl border border-zinc-800 bg-zinc-950 p-4">
      <p className="text-xs text-zinc-500">{label}</p>
      <p className="mt-1 font-display text-2xl font-bold" style={{ color: tint }}>{val}</p>
    </div>
  );
  return (
    <div className="space-y-4" data-testid="sa-subscriptions">
      <h1 className="font-display text-2xl font-bold text-white">Abonnements</h1>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-5">
        {card("Essai", c.trial, "#FFD500", "sa-sub-trial")}
        {card("Actifs", c.active + c.past_due, "#34d399", "sa-sub-active")}
        {card("En pause", c.paused, "#f87171", "sa-sub-paused")}
        {card("Résiliés", c.canceled, "#a1a1aa", "sa-sub-canceled")}
        {card("Taux de conversion", fin.conversion_rate + "%", "#FF6A00", "sa-sub-conversion")}
      </div>
      <div className="grid gap-3 sm:grid-cols-2">
        {card("MRR (récurrent mensuel)", eurf(fin.mrr), "#FF6A00")}
        {card("ARR (annualisé)", eurf(fin.arr), "#38bdf8")}
      </div>
      <div className="rounded-2xl border border-zinc-800 bg-zinc-950 p-4">
        <p className="mb-3 text-sm font-semibold text-white">Conversion essai → payant (6 mois)</p>
        <ResponsiveContainer width="100%" height={240}>
          <BarChart data={fin.conversion_series || []} margin={{ top: 8, right: 8, left: -12, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#27272a" vertical={false} />
            <XAxis dataKey="month" tick={{ fill: "#a1a1aa", fontSize: 12 }} axisLine={{ stroke: "#3f3f46" }} tickLine={false} />
            <YAxis tick={{ fill: "#a1a1aa", fontSize: 12 }} axisLine={false} tickLine={false} unit="%" />
            <Tooltip contentStyle={tipStyle} cursor={{ fill: "#ffffff08" }} formatter={(v) => v + "%"} />
            <Bar dataKey="rate" name="Taux de conversion" fill="#FF6A00" radius={[6, 6, 0, 0]} maxBarSize={40} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
